module.exports = "/packs/about-she-creators-section-image-078fad6b0f911e800155b2c6bb4a1557.png";